module.exports = __webpack_public_path__ + "23405873ffd438e44aa4d5b68efaa231.woff";